export default __webpack_public_path__ + "static/media/rating-desc.422f39fa.png";